import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmailIntegrationService } from 'src/app/_services/email-integration.service';
import { LoadingService } from 'src/app/_services/loading.service';
declare const clevertap;
@Component({
    selector: 'app-email-redirection',
    templateUrl: './email-redirection.component.html',
    styleUrls: ['./email-redirection.component.scss'],
    standalone: false
})
export class EmailRedirectionComponent implements OnInit {

  constructor(private emailintegrationservice: EmailIntegrationService,private route : ActivatedRoute , private loader : LoadingService) { }

  ngOnInit() {
    let code = this.route.snapshot.queryParamMap.get('code');
    let integrate = this.route.snapshot.queryParamMap.get('integrate');
    const errorCode = this.route.snapshot.queryParamMap.get('error');
    
    if(errorCode == 'access_denied'){
      window.close();
      return;
    }
    if(code){
      window.history.replaceState( {} , '', window.location.origin + window.location.pathname );
      let data ={
        redirectionurl : window.location.origin + window.location.pathname,
        code : code
      }
      this.loader.startLoading()
      if(integrate == 'gmail'){
        data.redirectionurl = data.redirectionurl +'?integrate=gmail'
        this.emailintegrationservice.savegmaildetails(data).subscribe((res:any)=>{
          if(res.status == 'success'){
            localStorage.setItem("gmail_integration", res.status);
            clevertap.event.push('IntegrationSuccess_Gmail');
            localStorage.setItem("gmail_integration_completed", res.status);
            setTimeout(()=> {
              window.close();  
          }, 1000);
          } else{
            localStorage.setItem("gmail_integration", res.message);
            window.close();  
          }
        })
      }else{
        this.emailintegrationservice.saveoutlookdetails(data).subscribe((res:any)=>{
          if(res.status == 'success'){
            localStorage.setItem("outlook_integration", res.status);
            clevertap.event.push('IntegrationSuccess_Outlook');
            localStorage.setItem("outlook_integration_completed", res.status);
            setTimeout(()=> {
              window.close();  
          }, 1000); 
          }else{
            localStorage.setItem("outlook_integration", res.message);
            window.close();  
          }
        })
      }
      
    } else{
      window.close();
    }
  }
}
